module.exports = __webpack_public_path__ + "static/media/tachometer-fast.e3252482.svg";